import React from 'react';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import './OpSchedulerToolbar.css';

export function AddButton({ onClick }) {
  return (
    <ButtonComponent
      cssClass="op-scheduler-header__button e-inherit"
      iconCss="e-icons e-circle-add"
      title="Add Event"
      onClick={onClick}
      style={{
        background: 'inherit',
        boxShadow: 'none',
        border: 'none',
        padding: '7px',
        borderRadius: '0',
      }}
    />
  );
}

export function SettingsButton({ onClick }) {
  return (
    <ButtonComponent
      cssClass="op-scheduler-header__button op-scheduler-settings-toggle e-inherit"
      iconCss="e-icons e-settings"
      title="Settings"
      onClick={onClick}
      style={{
        background: 'inherit',
        boxShadow: 'none',
        border: 'none',
        padding: '7px',
        borderRadius: '0',
      }}
    />
  );
}

export function FullscreenButton({ onClick, isFullscreen }) {
  return (
    <ButtonComponent
      cssClass="op-scheduler-header__button e-inherit"
      iconCss={isFullscreen ? 'e-icons e-exit-full-screen' : 'e-icons e-full-screen'}
      title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
      onClick={onClick}
      style={{
        background: 'inherit',
        boxShadow: 'none',
        border: 'none',
        padding: '7px',
        borderRadius: '0',
      }}
    />
  );
}

function OpSchedulerToolbar({
  header = {},
  onAdd = () => {},
  onSettings = () => {},
  onFullscreen = () => {},
  showAddButton = true,
  showSettingsButton = true,
  showFullscreenButton = true,
  isFullscreen = false,
}) {
  const renderAddButton = () => (showAddButton ? <AddButton onClick={onAdd} /> : null);
  const renderSettingsButton = () =>
    showSettingsButton ? <SettingsButton onClick={onSettings} /> : null;
  const renderFullscreenButton = () =>
    showFullscreenButton ? (
      <FullscreenButton onClick={onFullscreen} isFullscreen={isFullscreen} />
    ) : null;

  const renderContext = {
    onAdd,
    onSettings,
    showAddButton,
    renderAddButton,
  };

  const renderSection = (render) => (typeof render === 'function' ? render(renderContext) : null);
  const renderRight =
    typeof header.right === 'function' ? header.right(renderContext) : <>{renderAddButton()}</>;

  return (
    <div className="op-scheduler-header">
      <div className="op-scheduler-header__left">{renderSection(header.left)}</div>
      <div className="op-scheduler-header__center">{renderSection(header.center)}</div>
      <div className="op-scheduler-header__right">
        {renderRight}
        {renderSettingsButton()}
        {renderFullscreenButton()}
      </div>
    </div>
  );
}

export default OpSchedulerToolbar;
